import { styled, DSTag } from '@vr/ds-react'

export const MessageCopy = styled(DSTag, {
  '&.show': {
    opacity: 1,
    visibility: 'visible'
  },
  '&.hide': {
    opacity: 0,
    transition: 'opacity 0.5s linear, visibility 0s 0.5s',
    visibility: 'hidden'
  }
})
